<template>
  <div class="content-page">
    <div class="main-page">
      <div class="title-page"></div>
      <div class="backgroundBox" >
        <div class="main-contentBox" v-show="contentList.length>0">
        <div class="star-title">
          <span class="star"></span>特别提醒事项
        </div>
        <div class = "contentBox tip-contentBox">
            <div class="textBox" >
              <div class="paragraph" v-for="(item,index) in contentList" :key="index" >
               {{item.content}}
                 <div class="text-content" v-for="(ite,index) in item.children" :key="index" >
                   {{ite.content}}
                 </div>
              </div>
            </div>
        </div>
        <p class="checked-text"><el-checkbox v-model="checked"></el-checkbox> &nbsp;&nbsp;我已阅读，接受上述规定，愿意承担相关法律责任并做好了准备，希望进行网上申请操作。</p>
        <div class="btnLists">
          <div @click="interApply" v-if="isShow"  class="primary-btn">进入网上申请 <span v-if="!isShow"> ( {{downNumber}} ) </span> </div>
          <div class="gary-btn" v-else>进入网上申请 ( {{downNumber}} )  </div>
          <div class="border-btn" style="marginLeft:20px" @click="$router.push('/codeSearch')" >返回上一页</div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@api/api'
export default {
  data () {
    return {
      contentList: [],
      checked: false,
      isShow: false,
      downNumber: 5 // 倒数字
    }
  },
  created () {
    this.startDownNumber()
    this.getDescribeTex()
  },
  methods: {
    getDescribeTex () {
      Api.getDescribeTex({ type: 'remind' }).then(res => {
        this.contentList = res.data.data
        console.log(res.data.data)
      })
    },
    // 倒计时
    startDownNumber () {
      this.isShow = false
      this.downNumber = 5
      var times = setInterval(() => {
        this.downNumber--
        if (this.downNumber <= 0) {
          this.isShow = true
          clearInterval(times)
        }
      }, 1000)
    },
    // 进入网上申请
    interApply () {
      if (!this.checked) {
        this.$message.warning('请先阅读网上申请须知')
        return
      }
      this.$router.push('/howApply')
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1000px) { 
  .tip-contentBox{
    .textBox{
      // margin-top: 500px !important;
    }
  }
  .contentBox{
    display: block !important;
  }
}

.main-contentBox{
  width: 100%;
  padding: 3% 8% 4%;
  .star-title{
    margin-bottom: 20px;
  }
  .tip-contentBox{
    height: 418px;
    overflow: auto;
    .textBox{
      padding:0 20px;
    .paragraph{
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #333333;
      line-height: 36px;
    }
    .text-content{
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #666666;
      line-height: 28px;
      margin-left: 30px;
    }
  }
  }
  .checked-text{
    margin-top: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    width: 100%;
    // height: 100px;
  }
  
}
</style>
